import { render, staticRenderFns } from "./dis.vue?vue&type=template&id=4a02b9d0&scoped=true&"
import script from "./dis.vue?vue&type=script&lang=js&"
export * from "./dis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02b9d0",
  null
  
)

export default component.exports